import { FormControl, TextField } from "@mui/material";
import { ChangeEvent } from "react";

export interface INumberInputProps {
    label: string;
    value: number | null;
    onChange: (value: number | null) => void;
}

export function NumberInput(props: INumberInputProps) {

    const onChange = (event:ChangeEvent<HTMLInputElement>) => {        
        const parsedNumber = parseFloat(event.target.value);
        const value = isNaN(parsedNumber) ? null : parsedNumber;                
        props.onChange( value );        
    }

    return (
        <FormControl>
            <TextField 
                type="number"
                label={props.label}
                variant="standard"
                onChange={onChange}
                value={props.value ?? ""}
                >                    
            </TextField>
        </FormControl>
    )
}